import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';

import { store, } from './store';
// Main Application
import Pages from './pages';
import TranslationProvider from './i18n/Provider';
// Custom CSS Styling
import './custom.css';
// import 'semantic-ui-css/semantic.min.css';
import 'semantic-ui-less/semantic.less';
import 'react-toastify/dist/ReactToastify.css';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <TranslationProvider>
        <Pages />
      </TranslationProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
